import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import { formatDateTime, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { currentDateAndTime, decodeData } from "../../Constants/constants";
// import TooltipComponent from "../../Components/TooltipComponent";
import { formatDate} from "../../Components/InputElements";
class AssignShiftes extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      company_location_shift_id: 0,
      effective_date: null,
      location_shift_id: "",
      location_id: "",
      department_id: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      Shift_rows: [],
      get_location_row: [],
      department_rows: [],
      location_row: [],
      company_location_shift_row: [],
      days_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      loadingFilter: false,
      loadingSearch: false,
      decodedData: [],
      viewDetails:false,
      employee_code:'',
      employee_name:'',
      designation_title:'',
      
      department_title:'',
      company_location_shift_name:'',
      assigned_by:'',
      effective_date:'',
      created_date:'',
    };
   
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetShiftList();
      this.GetLocationList();
      this.GetDepartmentMasters();
      // this.GetView();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context; // Extract API URL and headers from context
    const headers = apiHeaderJSON; // Define headers
    
    // Axios GET request
    axios
      .get(`${apiURL}Employees/GetEmployeesByShift`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          location_id: this.state.location_id,
          department_id: this.state.department_id,
          company_location_shift_id: this.state.location_shift_id,
        },
        headers,
      })
      .then((response) => {
        // Check if the API call was successful
        if (response.data.success === true) {
          const data = response.data;
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingFilter: false,
            loadingSearch: false,
          });
        } else {
          // Handle unsuccessful API response
          this.setState({
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
        }
      })
      .catch((error) => {
        // Handle API errors
        console.error("Error fetching data:", error);
        this.setState({
          loadingList: false,
          loadingSearch: false,
          loadingFilter: false,
        });
      });
  };
  
 
  
  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    var formData = {
      employee_id: this.state.selectedRows,
      company_location_shift_id: this.state.company_location_shift_id,
      effective_date: this.state.effective_date,
      current_date: currentDateAndTime(),
    };
    // console.log("form data ====>>>", formData);
    Swal.fire({
      title: 'Please wait...',
      html: 'Shift assigning to employees.',
      allowOutsideClick: false,
      didOpen: () => {
          Swal.showLoading();
      }
    });
    axios
      .post(`${apiURL}Employees/AssignShift`, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          this.setState(
            {
              loadingList: true,
              selectedRows: [],
              company_location_shift_id: "",
              effective_date: "",
            },
            (prevState) => {
              this.GetList();
              this.GetLocationList();
              this.GetDepartmentMasters();
              this.GetShiftList();
            }
          );
        } else {
          this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetShiftList();
            this.GetLocationList();
          });
        }
        Swal.close();
        Swal.fire({
          title: `<strong>${
            response.data.success === true ? "Success" : "Failed"
          }</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? "success" : "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      })
      .catch((error)=>{
        Swal.close();
        Swal.fire({
          title: `<strong>Failed}</strong>`,
          text: "Opps...! Something went wrong.",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      });
  };

  handleInputSearch = (e) => {
    this.setState({ loadingSearch: true }, () => {
      this.GetList();
    });
  };
  handleClearAll = () => {
    this.setState(
      {
        location_id: "",
        department_id: "",
        location_shift_id: "",
        keyword: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
      },
      () => {
        this.GetList();
      }
    );
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    },
    () => {
      if (this.state.keyword === "") {
        this.GetList();
      }
    });
  };

  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows =
        prevState.selectedRows.length === prevState.rows.length
          ? []
          : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === "select-all") {
      this.setState({
        selectedRows: this.state.rows.map((row) => row.employee_id),
      });
    } else if (action === "deselect-all") {
      this.setState({ selectedRows: [] });
    }
  };

  GetShiftList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetShiftList `, { headers })
      .then((response) => {
        const data = response.data;
        if (response.data.success === true) {
          const shifts = data.data.map((row) => ({
            value: row.company_location_shift_id,
            label: row.company_location_shift_name,
          }));
          shifts.unshift({ value: "unassigned", label: "Not Assigned" });
          this.setState((prevState) => ({
            Shift_rows: shifts || []
          }));
        }
      });
  };
  GetView = (row) => {
    console.log("GetView", row);

    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    
    axios
      .get(`${apiURL}Masters/GetShiftsViewList`, {
        params: {
          employee_id: row?.employee_id || "",
        },
        headers,
      })
      .then((response) => {
        // console.log("data===>", response.data);
        
        if (response.data.success === true && response.data.data.length > 0) {
          this.setState({
            viewDetails: true,
            shiftDataList: response.data.data, 
          });
        } else {
          this.setState({
            viewDetails: true,
            shiftDataList: [], 
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.setState({ loadingList: false, loadingSearch: false });
      });
};

//   GetView = (row) => {
//     console.log("GetView", row);

//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;
    
//     axios
//       .get(`${apiURL}Masters/GetShiftsViewList`, {
//         params: {
//           employee_id: row?.employee_id || "",
//         },
//         headers,
//       })
//       .then((response) => {
//         console.log("data===>", response.data);
        
//         if (response.data.success === true && response.data.data.length > 0) {
//           let shiftData = response.data.data[0]; // Extract first object from array

//           this.setState({
//             viewDetails: true,
//             employee_code: shiftData.employee_code || "",
//             employee_name: shiftData.employee_name || "",
//             designation_title: shiftData.designation_title || "",
//             department_title: shiftData.department_title || "",
//             company_location_shift_name: shiftData.company_location_shift_name || "",
//             assigned_by: shiftData.assigned_by || "",
//             effective_date: shiftData.effective_date || "",
//             created_date: shiftData.created_date ? shiftData.created_date.split(" ")[0] : "", // Extracting only the date part
//           });
          
//         } else {
//           this.setState({
//             viewDetails: true,
//             employee_code: "",
//             employee_name: "",
//             designation_title: "",
//             department_title: "",
//             company_location_shift_name: "",
//             assigned_by: "",
//             effective_date: "",
//             created_date: "",
//           });
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       })
//       .finally(() => {
//         this.setState({ loadingList: false, loadingSearch: false });
//       });
// };

  // GetView = (row) => {
  //   console.log("GetView",row);
   
  //   const { apiURL, apiHeaderJSON } = this.context;
  //   const headers = apiHeaderJSON;
  //   axios
  //     .get(`${apiURL}Masters/GetShiftsViewList`, {
  //       params: {
         
  //         employee_id: row?.employee_id || "",

  //     },
  //       headers,
  //     })
  //     .then((response) => {
  //       var data = response.data;
  //       console.log("data===>",data)
       
  //       if (response.data.success === true) {
  //         this.setState({
  //           viewDetails: true,
  //           employee_code: data.employee_code || "",
  //           employee_name: data.employee_name || "",
  //           designation_title: data.designation_title || "",
  //           assigned_by: data.assigned_by || "",
  //           assign_shift: data.assign_shift || "",
  //           effective_date: data.effective_date || "",
  //           created_date: data.created_date || "",
            
  //         });
          
  //       } else {
  //         this.setState({
  //           employee_code: data?.employee_code,
  //           employee_name: data?.employee_name,
  //           designation_title: data?.designation_title,
  //           department_title: data?.department_title,
  //           assign_shift: data?.assign_shift || '',
  //           assigned_by: data?.assigned_by,
  //           effective_date: data?.effective_date,
  //           created_date: data?.created_date,

  //           // formData:{
  //           //     file: row?.document_url,
  //           // },
  //           viewDetails: true,
  //           fileView: true
  //       }, ()=>{

  //           console.log("this.state.viewDetails",this.state.viewDetails)
  //       });
  //       }
  //     }).catch((error)=>{
  //       console.log(error);
  //     })
  //     .finally(this.setState({ loadingList: false, loadingSearch:false }));
  // };
  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then((response) => {
      var data = response.data.data.department;
      if (response.data.success === true) {
        this.setState((prevState) => ({
          department_rows: data.map((row) => ({
            value: row.department_id,
            label: row.department_title,
          })),
        }));
      }
    });
  };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            get_location_row: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
          this.GetShiftList();
          this.GetLocationList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
        this.GetShiftList();
        this.GetLocationList();
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };
  

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Assign Shifts`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="keyword">Candidate Name</label>
                        <div className="input-group">
                          <input
                            type="search"
                            className="form-control"
                            onChange={this.handleInputChange}
                            name="keyword"
                            value={this.state.keyword}
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder="Search Name"
                          />
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingSearch}
                            onClick={() => {
                              if (
                                this.state.keyword &&
                                !this.state.loadingSearch
                              ) {
                                this.handleInputSearch();
                              }
                            }}
                            type="button"
                            id="button-addon2"
                          >
                            {this.state.loadingSearch ? (
                              <span
                                class="spinner-border flex-shrink-0"
                                role="status"
                                style={{
                                  width: "0.8rem",
                                  height: "0.8rem",
                                  borderWidth: "2px",
                                }}
                              >
                                <span class="visually-hidden">Loading...</span>
                              </span>
                            ) : (
                              <i className="ri-search-line"></i>
                            )}
                          </button>
                        </div>
                      </div>
                      <div className="col-md-3 position-relative">
                          <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                            <div>
                              <label>Check Location</label>
                            </div>
                            <Select
                              options={this.state.get_location_row}
                              value={
                                this.state.location_id
                                  ? this.state.get_location_row.find(
                                      (option) =>
                                        option.value === this.state.location_id
                                    )
                                  : null
                              }
                              onChange={(selectedOption) =>
                                this.handleSelectChange(
                                  "location_id",
                                  selectedOption
                                )
                              }
                              placeholder={`Select Location`}
                            />
                        </div>
                      </div>
                      <div className="col-md-3 position-relative">
                        <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                          <div>
                            <label>Check Department</label>
                          </div>
                          <Select
                            onChange={(selectedOption) =>
                              this.handleSelectChange(
                                "department_id",
                                selectedOption
                              )
                            }
                            placeholder={`Select Department`}
                            options={this.state.department_rows}
                            value={
                              this.state.department_id
                                ? this.state.department_rows.find(
                                    (option) =>
                                      option.value === this.state.department_id
                                  )
                                : null
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-3 position-relative">
                        <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                          <div>
                            <label>Check Shift</label>
                          </div>
                          <Select
                            onChange={(selectedOption) =>
                              this.handleSelectChange(
                                "location_shift_id",
                                selectedOption
                              )
                            }
                            placeholder={`Select Shift`}
                            options={this.state.Shift_rows}
                            value={
                              this.state.location_shift_id
                                ? this.state.Shift_rows.find(
                                    (option) =>
                                      option.value ===
                                      this.state.location_shift_id
                                  )
                                : null
                            }
                          />
                        </div>
                      </div>
                      <div style={{ width: "11%" }} className="col-md-2 mt-3">
                      <div>
                        <label>Apply Filter</label>
                      </div>
                      {this.state.loadingFilter === "1" ? (
                        <button className="btn btn-info btn-load">
                          <span className="d-flex align-items-center">
                            <span
                              className="spinner-border flex-shrink-0"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </span>
                            <span className="flex-grow-1 ms-2">Loading...</span>
                          </span>
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            this.setState(
                              {
                                loadingFilter: "1",
                              },
                              () => {
                                this.handleInputSearch();
                                console.log(
                                  "this.state.loadingFilter1 ==>",
                                  this.state.loadingFilter
                                );
                              }
                            );

                            // console.log("this.state.loadingFilter ==>" + this.state.loadingFilter);
                          }}
                          className={`w-100 btn btn-info btn-label waves-effect waves-light ${
                            !this.state.keyword &&
                            this.state.from_date === "" &&
                            this.state.to_date === "" &&
                            this.state.selectOption === "" &&
                            !this.state.filter_leave_type_id
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                          Filter
                        </button>
                      )}
                    </div>
                    <div style={{ width: "11%" }} className="col-md-3 mt-3">
                      <div>
                        <label>Clear Filter</label>
                      </div>
                      {this.state.loadingFilter === "2" ? (
                        <button className="btn btn-secondary btn-load">
                          <span className="d-flex align-items-center">
                            <span
                              className="spinner-border flex-shrink-0"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </span>
                            <span className="flex-grow-1 ms-2">Loading...</span>
                          </span>
                        </button>
                      ) : (
                        <button
                          type="button"
                          className={`btn w-100 noWrap btn-secondary btn-label waves-effect waves-light ${
                            !this.state.keyword &&
                            this.state.from_date === "" &&
                            this.state.selectOption === "" &&
                            this.state.to_date === "" &&
                            !this.state.filter_leave_type_id
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() => {
                            this.setState({ loadingFilter: "2" }, () => {
                              this.handleClearAll();
                              console.log(
                                "this.state.loadingFilter1 ==>",
                                this.state.loadingFilter
                              );
                            });
                          }}
                        >
                          <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 noWrap"></i>{" "}
                          Clear
                        </button>
                      )}
                    </div>
                    { this.state.decodedData?.includes(3) && (
                      <div className='col-md-3 mt-3'>
                        <div>
                          <label>Assign Shifts</label>
                        </div>
                        <button
                          data-bs-toggle="modal"
                          data-bs-target={`#varyingcontentModal`}
                          type="button"
                          className={`btn btn-success btn-label waves-effect right waves-light ${(this.state.selectedRows.length === 0) ? 'disabled' : ''}`}>
                          <i className="ri-user-settings-line label-icon align-middle fs-16 ms-2" />
                          Assign Shifts
                        </button>
                      </div>)}
                    </div>
                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-hover`}>
                      <thead className="table-light">
                        <tr>
                        { this.state.decodedData?.includes(3) && (
                          <th>
                            <div
                              className="btn-group"
                              style={{ background: "rgb(221 224 227)" }}
                            >
                              <button type="button" className="btn">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={
                                    this.state.selectedRows.length ===
                                    this.state.rows.length
                                  }
                                  onChange={this.handleSelectAll}
                                />
                              </button>
                              <button
                                type="button"
                                className="btn dropdown-toggle dropdown-toggle-split"
                                id="dropdownMenuReference"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                data-bs-reference="parent"
                                style={{ background: "#c7c7c7" }}
                              >
                                <span className="visually-hidden">
                                  Toggle Dropdown
                                </span>
                              </button>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuReference"
                              >
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() =>
                                      this.handleSelectAllDropdown("select-all")
                                    }
                                  >
                                    Select All
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() =>
                                      this.handleSelectAllDropdown(
                                        "deselect-all"
                                      )
                                    }
                                  >
                                    Deselect All
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </th>)}
                          <th>Employee Code</th>
                          <th>Employee Name</th>
                          <th>Employee Mobile Number</th>
                          <th>Employee Email Address</th>
                          <th>Assigned Shifts</th>
                          {(this.state.decodedData?.includes(1) &&(
                              <th width="100" className="text-center">
                                Action
                              </th>))}
                        </tr>
                      </thead>
                      {this.state.rows.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={11}>
                              <NoRecords />
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {this.state.rows.map((row) => {
                            return (
                              <tr key={row.employee_id}>
                                { this.state.decodedData?.includes(3) && (
                                <td>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={this.state.selectedRows.includes(
                                        row.employee_id
                                      )}
                                      onChange={() =>
                                        this.handleCheckboxChange(
                                          row.employee_id
                                        )
                                      }
                                    />
                                  </div>
                                </td>)}
                                <td>{row.employee_code}</td>
                                <td>{row.employee_name}</td>
                                <td>{row.employee_mobile_number}</td>
                                <td>{row.employee_email_address}</td>
                                <td>
                                  {row.assign_shift || (
                                    <span className={`badge bg-info`}>
                                      UnAssign
                                    </span>
                                  )}
                                </td>
                                
                                    <td>
                                      <div className=" d-flex align-items-center justify-content-center gap-2">
                                      
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-primary"
                                          onClick={() => this.GetView(row)}
                                        >
                                          {/* <i className="bx bx-message-alt-detail label-icon align-middle fs-16 me-2" /> */}
                                          logs
                                        </button>
                                     
                                     
                                      {/* <TooltipComponent name="Logs" position="top">
                                                    <button
                                                        onClick={() =>{
                                                            if(!this.state.loadingLogs){
                                                                this.setState({loadingLogs:true},
                                                                    ()=>this.GetTeamExpenseLogList(row))
                                                            }
                                                            
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-secondary mr-2 text-center"
                                                        > 
                                                         {this.state.loadingLogs ? (
                                                            <span
                                                                class="spinner-border flex-shrink-0"
                                                                role="status"
                                                                style={{
                                                                width: "0.8rem",
                                                                height: "0.8rem",
                                                                borderWidth: "2px",
                                                                }}
                                                            >
                                                                <span class="visually-hidden">
                                                                Loading...
                                                                </span>
                                                            </span>
                                                            ) : (
                                                            <i className="ri-file-text-line"></i>
                                                            )}
                                                    </button>
                                      </TooltipComponent> */}

    
                                      </div>
                                    </td>
                                    
                              </tr>
                            );
                          })}
                        </tbody>
                      )}
                      <tfoot className="table-light">
                        <tr>
                          <th colSpan={8}>
                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  this.state.prev === false &&
                                  this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handlePrev()}
                                className={`btn btn-warning btn-label waves-effect waves-light`}
                              >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                Previous
                              </button>
                              <div
                                className="col-md-4"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {
                                  <small>
                                    Total Records: {this.state.total_records} |
                                    Total Pages: {this.state.total_pages} |
                                    Current Page: {this.state.page}
                                  </small>
                                }
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={(e) => this.handleChange(e)}
                                >
                                  {Array.from(
                                    { length: this.state.total_pages },
                                    (_, i) => (
                                      <option
                                        selected={this.state.page === i + 1}
                                        key={i}
                                        value={i + 1}
                                      >
                                        Page {i + 1}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={this.handleLimitChange}
                                  value={this.state.limit}
                                >
                                    <option value={this.state.total_records}>
                                      All
                                    </option>
                                  {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                      Limit {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <button
                                disabled={
                                  this.state.next === false &&
                                  this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                              >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                Next
                              </button>
                            </div>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  {this.state.viewDetails && (
                   <div className="modal show" 
                   style={{
                       display: "block",
                       backgroundColor: "rgba(0, 0, 0, 0.5)",
                   }} >
                   <div className="modal-dialog modal-xl"
                   style={{ width: "80%" }}
                   >
                       <div className="modal-content">
                       <div className="modal-header">
                           <h5 className="modal-title" id="exampleModalgridLabel">Assign Shift</h5>
                           <button type="button"
                           disabled={this.state.postLoading} className="btn-close" onClick={()=>{
                               this.setState({
                                  
                                   viewDetails:false,
                                 
                                  employee_code: "",
                                  employee_name: "",
                                  assign_shift: '',
                                  designation_title: "",
                                  company_location_shift_name: '',
                                  assigned_by:'',
                                  effective_date:'',
                                  created_date:'',
                               })
                           }} aria-label="Close" />
                       </div>
                       {/* <div className="modal-body">
                           <div className="container mt-2">
                           <form className="row">
                               <div className="col-md-6 mt-3">
                                   <label className="form-label">employee name</label>
                                      
                                       <input
                                       type="text"
                                       className={`form-control`}
                                       id="employee_name"
                                       name="employee_name"
                                       disabled
                                       value={this.state.employee_name}
                                       onChange={(e) => this.handleInputChange(e)}
                                   />
                               </div>     
                               <div className="col-md-6 mt-3">
                                   <label className="form-label">Employee Code</label>
                                       
                                       <input
                                       type="text"
                                       className={`form-control`}
                                       id="employee_code"
                                       name="employee_code"
                                       disabled
                                       value={this.state.employee_code}
                                       onChange={(e) => this.handleInputChange(e)}
                                   />
                               </div>     
                               <div className="col-md-6 mt-3">
                                   <label className="form-label">Designation Title</label>
                                       
                                       <input
                                       type="text"
                                       className={`form-control`}
                                       id="designation_title"
                                       name="designation_title"
                                       disabled
                                       value={this.state.designation_title}
                                       onChange={(e) => this.handleInputChange(e)}
                                   />
                               </div>     
                               <div className="col-md-6 mt-3">
                                   <label className="form-label">Assigned By</label>
                                       
                                       <input
                                       type="text"
                                       className={`form-control`}
                                       id="assigned_by"
                                       name="assigned_by"
                                       disabled
                                       value={this.state.assigned_by}
                                       onChange={(e) => this.handleInputChange(e)}
                                   />
                               </div>  
                               <div className="col-md-6 mt-3">
                                   <label className="form-label">company location shift name</label>
                                       
                                       <input
                                       type="text"
                                       className={`form-control`}
                                       id="company_location_shift_name"
                                       name="company_location_shift_name"
                                       disabled
                                       value={this.state.company_location_shift_name}
                                       onChange={(e) => this.handleInputChange(e)}
                                   />
                               </div>    
                               <div className="col-md-6 mt-3">
                                   <label htmlFor="effective_date" className="form-label">Effective Date</label>
                                   <input
                                       type="text"
                                       className={`form-control`}
                                       id="effective_date"
                                       name="effective_date"
                                       disabled
                                       value={this.state.effective_date? formatDate(this.state.effective_date):"--"}
                                   />
                               </div>      
                               <div className="col-md-6 mt-3">
                                   <label htmlFor="created_date" className="form-label">Assign Date</label>
                                   <input
                                       type="text"
                                       className={`form-control`}
                                       id="created_date"
                                       name="created_date"
                                       disabled
                                       value={this.state.created_date? formatDate(this.state.created_date):"--"}
                                   />
                               </div>              
                                 
                                         
                               
                           </form>
                           
                           </div>
                       </div> */}
                       {/* <div className="modal-body">
  <div className="container mt-2">
    <table className="table table-bordered text-center">
      <thead className="table-light">
        <tr>
        <th>Employee Code</th>
          <th>Employee Name</th>
          
          <th>Designation Title</th>
          <th>Shift Name</th>
          <th>Assigned By</th>
          <th>Effective Date</th>
          <th>Assign Date</th>
        </tr>
      </thead>
      <tbody>
        <tr>
        <td>{this.state.employee_code}</td>
          <td>{this.state.employee_name}</td>
        
          <td>{this.state.designation_title}</td>
          <td>{this.state.company_location_shift_name}</td>
          <td>{this.state.assigned_by}</td>
          <td>{this.state.effective_date ? formatDate(this.state.effective_date) : "--"}</td>
       
          <td>{this.state.created_date ?formatDate( this.state.created_date.split(" ")[0] ): "--"}</td>

        </tr>
      </tbody>
    </table>
  </div>
</div> */}

<div className="modal-body">
  <div className="container mt-2">
    <table className="table table-bordered text-center">
      <thead className="table-light">
        <tr>
          <th>Employee Code</th>
          <th>Employee Name</th>
          <th>Designation Title</th>
          <th>Shift Name</th>
          <th>Assigned By</th>
          <th>Effective Date</th>
          <th>Assign Date Time</th>
        </tr>
      </thead>
      <tbody>
        {this.state.shiftDataList && this.state.shiftDataList.length > 0 ? (
          this.state.shiftDataList.map((shift, index) => (
            <tr key={index}>
              <td>{shift.employee_code}</td>
              <td>{shift.employee_name}</td>
              <td>{shift.designation_title || "--"}</td>
              <td>{shift.company_location_shift_name || "--"}</td>
              <td>{shift.assigned_by || "--"}</td>
              <td>{shift.effective_date ? formatDate(shift.effective_date) : "--"}</td>
              {/* <td>{shift.created_date ? formatDate(shift.created_date.split(" ")[0]) : "--"}</td> */}
              <td>{shift.created_date ? formatDateTime(shift.created_date) : "--"}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7" className="text-center">No data available</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

                       </div>
                   </div>
               </div>
                  )}
                  
                </div>
                <div
                  className="modal fade"
                  id={`varyingcontentModal`}
                  tabIndex={-1}
                  aria-labelledby="varyingcontentModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5
                          className="modal-title"
                          id="varyingcontentModalLabel"
                        >
                          Assign Shifts
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        />
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="mb-3">
                            <label>Select Shift</label>
                            <Select
                              id="company_location_shift_id"
                              name="company_location_shift_id"
                              onChange={(selectedOption) =>
                                this.handleSelectChange(
                                  "company_location_shift_id",
                                  selectedOption
                                )
                              }
                              value={
                                this.state.company_location_shift_id
                                  ? this.state.Shift_rows.find(
                                      (option) =>
                                        option.value ===
                                        this.state.company_location_shift_id
                                    )
                                  : null
                              }
                              placeholder={`Select Shift`}
                              options={this.state.Shift_rows}
                            />
                          </div>
                          {/* Effective date */}
                          <div className="mb-3">
                            <TextBox
                              type="Date"
                              id="effective_date"
                              name="effective_date"
                              label="Effective Date"
                              value={this.state.effective_date}
                              change={this.handleInputChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-light"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          onClick={this.handleSubmit}
                          disabled={
                            !this.state.company_location_shift_id ||
                            !this.state.effective_date
                          }
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                        >
                          Assign
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AssignShiftes);
